// components/TableBody.jsx
import React from "react";
import OcrRow from "./OcrRow";

export default function TableBody({
  rows,
  selectedRow,
  setSelectedRow,
  setSelectedSymbol,
  setVolatility,     // 🔥 ADD
  timeframe,         // 🔥 ADD
  setZeroOCR,
  hoveredColumn,
  setHoveredColumn,
  td,
  divider,
  getCellStyle
}) {
  return (
    <tbody>
      {rows.map((row, idx) => (
        <OcrRow
          key={idx}
          row={row}
          idx={idx}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
          setSelectedSymbol={setSelectedSymbol}
          setVolatility={setVolatility}   // 🔥 PASS DOWN
          timeframe={timeframe}           // 🔥 PASS DOWN
          setZeroOCR={setZeroOCR}
          hoveredColumn={hoveredColumn}
          setHoveredColumn={setHoveredColumn}
          td={td}
          divider={divider}
          getCellStyle={getCellStyle}
        />
      ))}
    </tbody>
  );
}
